import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import WithdrawalRequestsListRequests from "./WithdrawalRequests";
import Table from "../../../Layout/Table/Table";
import NavBar from "../../../../components/NavBarAdmin";

const WithdrawalRequestsList = () => {
  const ActionColumn = ({ id }) => {
    return (
      <div>
        <Link
          to={`/my/admin/withdrawal-request/${id}/details`}
          className="btn btn-secondary btn-sm"
        >
          <i className="fa-solid fa-eye"></i>&nbsp; Detalhes
        </Link>
      </div>
    );
  };

  const InvoiceCheck = ({ data }) => {
    return data == 1 ? (
      <i className="fa-solid ms-5 fa-xl fa-circle-check"></i>
    ) : (
      <i className="fa-regular ms-5 fa-xl fa-circle"></i>
    );
  };

  const columns = [
    "Venue",
    "Data Pedido",
    "Data Processamento",
    "Data Pagamento",
    "Valor",
    "IBAN Pagamento",
    "Estado",
    "Actions",
  ];
  const serializeRowsColums = () => {
    return data.map((item) => {
      return {
        ...item,
        Actions: <ActionColumn id={item.id} />,
      };
    });
  };

  const [data, setData] = useState([]);
  useEffect(async () => {
    let info = await WithdrawalRequestsListRequests.getWithdrawalList();
    if (info && info.status) {
      setData(info.data.list);
    }
  }, []);

  return (
    <div>
      <NavBar>
        <div className="row">
          <div className="col-xs-12 dashboard-content">
            <div className="row">
              <div className="col-8">
                <h2 className="dashboard-h2"> Withdrawal List</h2>
              </div>
            </div>
            <div className="row">
              <div className="col-12 event-list-table">
                <Table
                  columns={columns}
                  data={serializeRowsColums(data)}
                  currentPage={1}
                  itemsPerPage={50}
                  totalItems={data.length}
                />
              </div>
            </div>
          </div>
        </div>
      </NavBar>
    </div>
  );
};

export default WithdrawalRequestsList;
